<svelte:options runes={true} />

<script lang="ts">
  import IconChevronRight from "~icons/dusk/chevron-right";

  interface Props {
    label: string;
    href?: string;
    onclick?: () => void;
    /** Set by a shell rendering this row inside a listbox — see SearchAutosuggestCore.items. */
    optionId?: string;
    selected?: boolean;
    class?: string;
  }

  let { label, href, onclick, optionId, selected, class: className = "" }: Props = $props();
</script>

<svelte:element
  this={href ? "a" : "button"}
  href={href || undefined}
  type={href ? undefined : "button"}
  {onclick}
  role={optionId ? "option" : undefined}
  id={optionId}
  aria-selected={optionId ? selected : undefined}
  tabindex={optionId ? -1 : undefined}
  class={["da-nav-menu-item-header", className]}
>
  <span class="da-nav-menu-item-header__label">{label}</span>
  <IconChevronRight
    class="da-nav-menu-item-header__icon"
    aria-hidden="true"
    width="20"
    height="20"
  />
</svelte:element>

<style>
  @layer aurora {
    .da-nav-menu-item-header {
      /* <button> takes the UA font (13.33px Arial) where <a> inherits the page's,
         which made the two branches different heights for identical content. */
      font: inherit;
      /* Full-width row with the chevron pushed to the far edge, per Figma
         9943:1457 — this is a heading row for the block above it, not a chip. */
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      gap: var(--da-space-2);
      padding: var(--da-space-3) 0;
      background: none;
      border: none;
      cursor: pointer;
      color: var(--da-color-charcoal-500);
      text-decoration: none;
      /* Matches NavMenuItem, so walking from the last term onto "Show all results"
         highlights at the same rate rather than snapping. */
      transition: background var(--da-duration-fast);
    }

    @media (prefers-reduced-motion: reduce) {
      .da-nav-menu-item-header {
        transition: none;
      }
    }

    /* sand-800 for the same reason as NavMenuItem: sand-500 disappears into the
       panel it is highlighted on. */
    .da-nav-menu-item-header[aria-selected="true"] {
      background: var(--da-color-brand-sand-800);
      border-radius: var(--da-radius-sm);
    }

    .da-nav-menu-item-header__label {
      font-family: var(--da-font-family-primary);
      font-weight: 600;
      font-size: var(--da-font-size-md);
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    :global(.da-nav-menu-item-header__icon) {
      flex-shrink: 0;
      display: block;
    }
  }
</style>
